<template>
  <!-- 公用组件  -->
  <div class="input_two">
    <span class="label_name" :class="isMust?'ismust':''">{{name}}</span>
    <span>
      <el-date-picker
        v-model="value1"
        :disabled="isdisable"
        type="date"
        placeholder="选择日期"
        size="mini"
        class="date_sty"
        value-format="yyyy-MM-dd"
      ></el-date-picker>
    </span>
  </div>
</template>

<script>
export default {
  name: "InputTwo",
  data() {
    return {
      value1: this.value
    };
  },
  methods: {

  },
  watch: {
    value1() {
      this.$emit("dateChange", this.value1, this.fieldData);
    },
    value(newVal){
      this.value1 = newVal;
    }
  },
  props: {
    value: [String, Object, Date],
    name: {
      type: String,
      default: "单据日期"
    },
    isdisable: {
      type: Boolean,
      default: false
    },
    isMust: {
      type: Boolean,
      default: true
    },
    // 传入的外部字段，将用于传出识别
    fieldData: { type: String }
  }
};
</script>

<style lang="less">
.input_two {
  width: 100%;
  height: 32px;
  display: -webkit-box !important;
  display: box !important;
  position: relative;
  -webkit-box-align: center;
  box-align: center;
  color: #666;
  border: 1px solid #d6e2ed;
  border-radius: 5px;
  padding: 0 5px;
  box-sizing: border-box;
  .label_name {
    height: 100%;
    line-height: 30px;
    font-size: 12px;
    color: inherit;
    font-weight: bold;
  }
  span,
  .label_name {
    display: block;
  }
  .ismust::after {
    content: "*";
    color: red;
  }
  .input_sty {
    position: relative;
    -webkit-box-flex: 1;
    box-flex: 1;
    display: block;
    height: 100%;
  }
  .el-input__inner,
  .el-input__inner:hover {
    border-color: #fff;
  }
  .el-input--suffix .el-input__inner {
    padding-right: 0;
    height: 27px;
  }
  .el-input__icon {
    width: 18px;
  }
  .date_sty {
    width: 70%;
  }
}
.input_two:hover {
  border-color: #2594ff;
  color: #2594ff;
}
</style>


// WEBPACK FOOTER //
// src/components/Input/InputTwo/InputTwo.vue